import intlTelInput from 'intl-tel-input';
import 'intl-tel-input/build/css/intlTelInput.css';
import FormHelpers from './form-helpers';
import ApiHelpers from './api-helper';

export default function IntlTelInput({ element }) {
	if (!element) return;
	const phoneInput = element;
	const form = phoneInput.closest('form');
	const disableSubmit = form.dataset?.disableSubmit === 'true';
	const submitBtn = form?.querySelector('input[type="submit"], button[type="submit"]');

	const acceptedCountryCodes = [
		'+355',
		'+376',
		'+43',
		'+375',
		'+32',
		'+387',
		'+359',
		'+3491',
		'+385',
		'+357',
		'+420',
		'+45',
		'+372',
		'+298',
		'+358',
		'+33',
		'+49',
		'+350',
		'+30',
		'+44',
		'+36',
		'+354',
		'+353',
		'+44',
		'+39',
		'+383',
		'+371',
		'+423',
		'+370',
		'+352',
		'+356',
		'+373',
		'+377',
		'+382',
		'+31',
		'+47',
		'+48',
		'+351',
		'+389',
		'+40',
		'+378',
		'+381',
		'+421',
		'+386',
		'+34',
		'+46',
		'+41',
		'+90',
		'+380',
		'+44',
		'+379',
	];

	async function validatePhoneNumber(phoneNumber) {
		try {
			const response = await ApiHelpers.post('CommunicationApi/ValidatePhoneNumber', {
				phoneNumber,
			});

			if (response?.responseContent) {
				return response.responseContent;
			}
			return false;
		} catch {
			return false;
		}
	}

	const disableSubmitButton = (state) => {
		if (disableSubmit && submitBtn) {
			submitBtn.disabled = state;
		}
	};

	const handleValidationError = () => {
		FormHelpers.createErrorBlock(phoneInput);
		disableSubmitButton(true);
	};

	const setFullPhoneNumber = (phoneNumber) => {
		const fullPhoneNumberInput = document.getElementById('fullPhoneNumber');
		if (!fullPhoneNumberInput) return false;

		fullPhoneNumberInput.value = phoneNumber || '';
		if (phoneNumber) {
			FormHelpers.removeErrorBlock(fullPhoneNumberInput);
			return true;
		}
		return false;
	};

	const lang = document.documentElement.lang || 'nl-NL';
	const initialCountryCode = lang.split('-')[1]?.toUpperCase() || 'NL';

	const iti = intlTelInput(phoneInput, {
		loadUtilsOnInit: `https://cdn.jsdelivr.net/npm/intl-tel-input@${intlTelInput.version}/build/js/utils.js`,
		separateDialCode: true,
		initialCountry: initialCountryCode,
		geoIpLookup: (callback) => {
			fetch('https://ipinfo.io/json')
				.then((response) => response.json())
				.then((data) => callback(data.country))
				.catch(() => callback('NL'));
		},
	});

	const countryCheck = () => {
		const countryCode = iti.getSelectedCountryData().dialCode;
		if (!acceptedCountryCodes.includes(`+${countryCode}`)) {
			handleValidationError();
			return false;
		}
		FormHelpers.removeErrorBlock(phoneInput);
		return true;
	};

	const validateInput = async () => {
		disableSubmitButton(true);

		if (!countryCheck()) return;

		const currentPhoneNumber = phoneInput.value.trim();
		if (currentPhoneNumber) {
			FormHelpers.removeErrorBlock(phoneInput);
			const isValidNumber = iti.isValidNumber();
			if (!isValidNumber) {
				handleValidationError();
				return;
			}
			const phoneNumber = iti.getNumber();
			const validMobile = await validatePhoneNumber(phoneNumber);
			if (!validMobile) {
				handleValidationError();
				return;
			}

			const phoneNumberUpdated = setFullPhoneNumber(phoneNumber);
			if (!phoneNumberUpdated) {
				handleValidationError();
				return;
			}

			disableSubmitButton(false);
		}
	};

	iti.promise.then(() => {
		validateInput();

		phoneInput.addEventListener('countrychange', validateInput);
		phoneInput.addEventListener('input', validateInput);
	});
}
